// extracted by mini-css-extract-plugin
module.exports = {"market":"uG00HgM_","marketOpen":"IN8NdCnI","dotIcon":"wfMFcptC"};